import axios from "axios";

export default {
  namespaced: true,
  state: {
    assets: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    assetsMessage: ''
  },
  mutations: {
    RECEIVED_ASSETS(state, payload) {
      state.assets = payload;
      state.isReceiving = false;
    },
    DO_NOTHING(state) {
      state.isReceiving = true;
      state.isReceiving = false;
    },
    RECEIVED_ASSET(state, payload) {
      console.log("RECEIVED ASSET", payload);
      state = Object.assign(state, {
        assets: [...state.assets, payload],
        isReceiving: false,
      })
    },
    RECEIVING_ASSET(state) {
      state.isReceiving = true;
    },
    UPDATED_ASSET(state, payload) {
      console.log(state.assets);
      console.log(payload);
      let index = state.assets.findIndex(asset => asset._id === payload._id);
      state = Object.assign(state, {
        assets: state.assets.map((asset, i) => {
          if (i === index) {
            return Object.assign({}, asset, payload);
          }
          return asset;
        }),
        isUpdating: false,
        assetsMessage: 'Assets has been updating!',
      })
    },
    UPDATING_ASSET(state) {
      state.isUpdating = true;
    },
    DELETED_ASSET(state, payload) {
      console.log("DELETE", payload);
      let indexToDelete = state.assets.findIndex(asset => asset._id === payload._id);
      console.log(indexToDelete);
      let assets = [...state.assets];
      assets.splice(indexToDelete, 1);
      state = Object.assign(state, {
        assets: [...assets],
        isDeleting: false,
        idToDelete: null,
        assetsMessage: 'Asset has been Deleted!',
      });
    },
    DELETING_ASSET(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async createQrcodeRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let data = {payload: payload}
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/create/qrcode';
        let response = await axios({method: "post", url: url, headers: headers, data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveAsset({commit}, payload) {
      console.log("HERE");
      console.log(payload);
      commit("RECEIVED_ASSET", payload)
    },
    receivingAsset({commit}) {
      commit("RECEIVING_ASSET")
    },
    updateAsset({commit}, payload) {
      commit("UPDATED_ASSET", payload)
    },
    updatingAsset({commit}) {
      commit("UPDATING_ASSET")
    },
    deleteAsset({commit}, payload) {
      console.log(payload);
      commit("DELETED_ASSET", payload)
    },
    deletingAsset({commit}, payload) {
      commit("DELETING_ASSET", payload)
    }
  },
};
